interface Props {
  value: number[];
  onChange: (next: number[]) => void;
}

/**
 * Compact 1–31 picker for a template's `scheduleDays`. Renders a flex-wrap
 * grid of small toggle chips. Full cron is YAGNI — ADR 0010 §1.
 */
export function ScheduleDaysPicker({ value, onChange }: Props) {
  const set = new Set(value);
  function toggle(day: number) {
    const next = new Set(set);
    if (next.has(day)) next.delete(day);
    else next.add(day);
    onChange(Array.from(next).sort((a, b) => a - b));
  }
  const days = Array.from({ length: 31 }, (_, i) => i + 1);
  return (
    <div className="template-schedule-grid" role="group" aria-label="Days of month">
      {days.map((d) => {
        const on = set.has(d);
        return (
          <button
            key={d}
            type="button"
            className={`template-schedule-day ${on ? 'is-on' : ''}`}
            aria-pressed={on}
            onClick={() => toggle(d)}
          >
            {d}
          </button>
        );
      })}
    </div>
  );
}
